"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToggleInput = exports.StyledToggleSwitch = exports.StyledToggleWrapper = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
exports.StyledToggleWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: 44px;\n  height: 32px;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  border-radius: 16px;\n  ", "\n"], ["\n  display: flex;\n  width: 44px;\n  height: 32px;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  border-radius: 16px;\n  ",
    "\n"])), function (_a) {
    var disabled = _a.disabled;
    return !disabled && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        &:hover {\n          background-color: ", ";\n        }\n        &:focus {\n          background-color: ", ";\n        }\n        &:active {\n          background-color: ", ";\n        }\n      "], ["\n        &:hover {\n          background-color: ", ";\n        }\n        &:focus {\n          background-color: ", ";\n        }\n        &:active {\n          background-color: ", ";\n        }\n      "])), theme_1.colors.green50, theme_1.colors.green50, theme_1.colors.green100);
});
exports.StyledToggleSwitch = styled_components_1.default.span({
    ':after': {
        borderColor: "" + theme_1.colors.transparent,
        borderRadius: '32px',
        borderStyle: 'solid',
        borderWidth: '1px',
        content: "''",
        height: "calc(100% + 6px)",
        left: '-4px',
        position: 'absolute',
        top: '-4px',
        transition: 'all .2s linear',
        width: "calc(100% + 6px)",
    },
    ':before': {
        backgroundColor: theme_1.colors.grey400,
        borderRadius: '50%',
        bottom: '2px',
        content: "''",
        height: '12px',
        left: '2px',
        position: 'absolute',
        transition: 'transform .1s linear, background-color .2s linear',
        width: '12px',
    },
    backgroundColor: theme_1.colors.transparent,
    borderColor: theme_1.colors.grey500,
    borderRadius: '32px',
    borderStyle: 'solid',
    borderWidth: '2px',
    boxSizing: 'border-box',
    display: 'inline-block',
    height: '20px',
    outline: 'none',
    position: 'relative',
    transition: 'all .1s linear',
    width: '32px',
});
exports.StyledToggleInput = styled_components_1.default.input((_a = {},
    _a[":checked + " + exports.StyledToggleSwitch] = {
        ':before': {
            backgroundColor: theme_1.colors.grey700,
            transform: 'translateX(12px)',
        },
        borderColor: theme_1.colors.grey700,
    },
    _a[":hover:enabled + " + exports.StyledToggleSwitch] = {
        ':before': { backgroundColor: theme_1.colors.grey700 },
    },
    _a[":disabled + " + exports.StyledToggleSwitch] = {
        borderColor: theme_1.colors.grey300,
        cursor: 'not-allowed',
        ':before': {
            backgroundColor: theme_1.colors.grey300,
        },
    },
    _a[":checked:disabled + " + exports.StyledToggleSwitch] = {
        borderColor: theme_1.colors.grey400,
        cursor: 'not-allowed',
        ':before': {
            backgroundColor: theme_1.colors.grey400,
        },
    },
    _a.display = 'none',
    _a));
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map